import type { DirectiveBinding, ObjectDirective } from 'vue'

interface ElWithTooltip extends HTMLElement {
  _tooltipEl?: HTMLDivElement
  _hideTimer?: ReturnType<typeof setTimeout>
  _clickHandler?: (e: MouseEvent) => void
}

type TooltipBinding = {
  html: string
  onClick?: (e: MouseEvent) => void
}

const tooltipDirective: ObjectDirective = {
  mounted(el: ElWithTooltip, binding: DirectiveBinding<TooltipBinding>) {
    const tooltip = document.createElement('div')

    tooltip.innerHTML = binding.value.html
    tooltip.className = 'custom-tooltip'
    tooltip.style.position = 'absolute'
    tooltip.style.zIndex = '9999'
    tooltip.style.padding = '6px 10px'
    tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
    tooltip.style.color = 'white'
    tooltip.style.borderRadius = '6px'
    tooltip.style.pointerEvents = 'auto'
    tooltip.style.transition = 'opacity 0.2s ease'
    tooltip.style.opacity = '0'
    tooltip.style.visibility = 'hidden'

    el._tooltipEl = tooltip
    document.body.appendChild(tooltip)

    const show = () => {
      const rect = el.getBoundingClientRect()
      tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2}px`
      tooltip.style.top = `${rect.top + window.scrollY - 10}px`
      tooltip.style.transform = 'translate(-50%, -100%)'
      tooltip.style.opacity = '1'
      tooltip.style.visibility = 'visible'
    }

    const hide = () => {
      el._hideTimer = setTimeout(() => {
        tooltip.style.opacity = '0'
        tooltip.style.visibility = 'hidden'
      }, 200)
    }

    tooltip.addEventListener('mouseenter', () => {
      if (el._hideTimer) clearTimeout(el._hideTimer)
    })
    tooltip.addEventListener('mouseleave', hide)

    el.addEventListener('mouseenter', show)
    el.addEventListener('mouseleave', hide)

    // Add click handler if exists
    if (binding.value.onClick) {
      el._clickHandler = (e: MouseEvent) => binding.value.onClick!(e)
      tooltip.addEventListener('click', el._clickHandler)
    }
  },

  // 👇 Thêm phần này để cập nhật khi `binding.value` thay đổi
  updated(el: ElWithTooltip, binding: DirectiveBinding<TooltipBinding>) {
    const tooltip = el._tooltipEl
    if (!tooltip) return

    // Cập nhật nội dung HTML
    tooltip.innerHTML = binding.value.html

    // Cập nhật lại event click nếu cần
    if (el._clickHandler) {
      tooltip.removeEventListener('click', el._clickHandler)
    }

    if (binding.value.onClick) {
      el._clickHandler = (e: MouseEvent) => binding.value.onClick!(e)
      tooltip.addEventListener('click', el._clickHandler)
    }
  },

  unmounted(el: ElWithTooltip) {
    if (el._tooltipEl) {
      el._tooltipEl.remove()
      el._tooltipEl = undefined
    }
    if (el._clickHandler) {
      el._clickHandler = undefined
    }
  }
}

export default tooltipDirective
